import { Center, Stack, Text, ThemeIcon } from "@mantine/core";
import type { ReactNode } from "react";

/**
 * Nothing to show, and what to do about it.
 *
 * An empty list is not an error and must not look like one. It gets a
 * headline, one sentence explaining why it is empty, and the action that
 * would fill it - because "No jobs" alone leaves the reader wondering whether
 * the app is broken or the day is quiet.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <Center py="xl">
      <Stack align="center" gap="sm" maw={360}>
        {icon && (
          <ThemeIcon size={44} radius="md" variant="light" color="gray">
            {icon}
          </ThemeIcon>
        )}
        <Text fz="lg" fw={600} c="gray.9" ta="center">
          {title}
        </Text>
        {description && (
          <Text fz="md" c="gray.6" ta="center" lh={1.45}>
            {description}
          </Text>
        )}
        {action}
      </Stack>
    </Center>
  );
}
